<script lang="ts" setup>
	import type { AtomBtnConfigClass } from '../ui/btn.vue'
	import type { IconLibProps } from '../tools/icon.vue'

	export type teamBenefitsContext = {
		title: string
		description: string
		icon: IconLibProps
	}[]

	defineProps<{
		title: string
		description: string
		productName: string
		btnLabel?: string
		teamBenefits: teamBenefitsContext
		ui?: {
			container?: Partial<AtomBtnConfigClass>
		}
	}>()
	defineEmits<{
		(event: 'trigger'): void
	}>()
</script>

<template>
	<div>
		<div class="max-w-[798px] mx-auto">
			<ui-title-header
				:title
				:ui="{
					size: 'text-[2rem]/[2.4rem] md:text-[2.625rem]/[3.15rem] lg:text-[3.25rem]/[3.9rem]',
					lineHeight: ''
				}"
				class="text-center max-w-[952px] mx-auto"
			/>

			<p class="text-gray-600 max-w-[620px] mx-auto md:text-xl text-base mt-5 text-center" v-html="description" />
		</div>

		<div class="flex items-start w-full flex-wrap gap-x-10 gap-y-8 sm:gap-y-20 justify-evenly mt-16 sm:mt-24">
			<ui-item-card
				v-for="(item, index) in teamBenefits"
				:key="index"
				:title="item.title"
				:description="item.description"
				class="max-w-[390px]"
			>
				<template #icon>
					<tools-icon
						:icon="String(item.icon.icon)"
						:dir="item.icon.dir"
						svg-class="md:h-[60px] md:w-[60px] xs:w-[36px] xs:h-[36px] w-[30px] h-[30px]"
					/>
				</template>
			</ui-item-card>
		</div>

		<div class="flex items-center justify-center w-full mt-14">
			<ui-btn
				:ui="{
					btn: {
						base: 'bg-health-500 min-h-[56px]',
						onHoverPseudo: 'hover:before:bg-health-800',
						width: ''
					},
					text: {
						base: 'text-white',
						font: 'font-medium'
					},
					...ui?.container
				}"
				@click="$emit('trigger')"
			>
				<span>{{ btnLabel ?? `Discover more about ${productName || 'N/A'}` }} </span>
				<template #icon>
					<slot name="hover-icon">
						<tools-icon dir="fill" icon="heart-rate-pulse" />
					</slot>
				</template>
			</ui-btn>
		</div>
	</div>
</template>
